// extracted by mini-css-extract-plugin
export var cookiebanner = "CookieBanner-module--cookiebanner--feb6d";